import { effect, Injectable, signal } from '@angular/core';
import { Franchise } from 'src/app/models/franchise.model';
import { CacheLoaderService } from './cache-loader.service';
import { AppAuthService } from '../app/auth.service';
import { Observable, of } from 'rxjs';
import { UserData } from '@/models/user-data.model';

@Injectable({
  providedIn: 'root'
})
export class OfficesService {
  offices = signal<Franchise[]>([]);

  selectedOffice = signal<Franchise | null>(null);

  constructor(
    private cacheLoader: CacheLoaderService<Franchise>,
    private appAuthService: AppAuthService
  ) { 
    effect(() => {
      const userData = this.appAuthService.userData();
      const offices = this.offices();
      if(userData && offices.length > 0) {
        this.setDefaultOffice(userData);
      }
    });

    if(this.offices().length === 0) {
      this.fetchOffices();
    }
  }

  fetchOffices() {
    console.log('fetching offices');
    this.cacheLoader.loadData('franchises', (offices) => {
      this.offices.set(offices);
    }, 'franchisesCacheKey');
  }

  setSelectedOffice(office: Franchise | null) {
    this.selectedOffice.set(office);
  }

  setSelectedOfficeById(id: number) {
    const office = this.offices().find(o => o.FID === id);
    if(office) {
      this.selectedOffice.set(office);
    }
  }

  setDefaultOffice(userData: UserData) {
    const defaultId = userData.defaultFID;
    if(defaultId) {
      this.setSelectedOfficeById(defaultId);
    }
  }

  getFilteredOffices(table: string, permType: string) {
    const perms = this.appAuthService.userPerms()?.filter(perm => perm.dataTable === table && perm.permType === permType);
    if(!perms) {
      return [];
    }
    else if(perms?.filter(perm => perm.FID === null).length > 0) {
      return this.offices().sort((a, b) => a.Title.localeCompare(b.Title));
    } else {  
      return this.offices().filter(office => perms?.some(perm => perm.FID === office.FID)).sort((a, b) => a.Title.localeCompare(b.Title));
    }
  }

  getFIDsByTableName(profile: any, tableName: string, actions?: string[]): Observable<{ [action: string]: number[] }> {
    const result: { [action: string]: number[] } = {};

    if (profile.UserRoles) {
      profile.UserRoles.forEach((userRole: any) => {
        if (userRole.PermRoles && userRole.PermRoles.RoleAccess) {
          userRole.PermRoles.RoleAccess.forEach((roleAccess: any) => {
            const permTitle = roleAccess.AccessPermissions.PermTitle;
            const [permTableName, , action] = permTitle.split('.');

            console.log(`Checking permTitle: ${permTitle}, permTableName: ${permTableName}, action: ${action}`);

            if (permTableName === tableName) {
              if (!result[action]) {
                result[action] = [];
              }
              result[action].push(userRole.PermRoles.FID);
            }
          });
        }
      });
    }

    console.log('Result before filtering:', result);

    if (actions) {
      const filteredResult: { [action: string]: number[] } = {};
      actions.forEach(action => {
        if (result[action]) {
          filteredResult[action] = result[action];
        }
      });
      console.log('Filtered result:', filteredResult);
      return of(filteredResult);
    }

    return of(result);
  }

  lookupFranchiseById(id: number | null): Franchise | null {
    const franchise = this.offices().find(f => f.FID === id);
    if (franchise) {
      return franchise
    }
    return null;
  }

  getFIDByAssemblyType(assemblyType: string) {
    if(assemblyType === 'O') {
      return this.selectedOffice()?.Options_FID || this.selectedOffice()?.FID || 0;
    } else {
      return this.selectedOffice()?.Standards_FID || this.selectedOffice()?.FID || 0;
    }
  }
}
